import { render, staticRenderFns } from "./articlesTable.vue?vue&type=template&id=2f7a9bde&scoped=true"
import script from "./articlesTable.vue?vue&type=script&lang=js"
export * from "./articlesTable.vue?vue&type=script&lang=js"
import style0 from "./articlesTable.vue?vue&type=style&index=0&id=2f7a9bde&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a9bde",
  null
  
)

export default component.exports